import { WaterCharacteristicsPreference } from "@src/core/api/waterCharacteristicsPreferences";
import { utilsRepository } from "@src/core/engine/utils/utilsRepository";
import { UnitConversionFn } from "@src/shared/hooks/useUnitConversion";
import { isEmpty, set, unique } from "radashi";
import {
  isDifferentialTemperatureValid,
  isPowerValid,
} from "../../components/BatchSelectionDataTable/helpers/getColumnsValidation";
import { BatchSelectionRow } from "../types";

export type HandlePowerToFlowConversionArgs = {
  convertToInternationalUnit: UnitConversionFn;
  convertToUserUnit: UnitConversionFn;
  prevRow: BatchSelectionRow | undefined;
  row: BatchSelectionRow;
  useFlowOrPower: string;
  waterCharacteristics: WaterCharacteristicsPreference | null;
};

export function handlePowerToFlowConversion({
  convertToInternationalUnit,
  convertToUserUnit,
  prevRow,
  row,
  useFlowOrPower,
  waterCharacteristics,
}: HandlePowerToFlowConversionArgs): BatchSelectionRow {
  if (useFlowOrPower === "flow") return row;
  const { differentialTemperature: deltaT, power } = row;
  if (
    prevRow &&
    prevRow.differentialTemperature === deltaT &&
    prevRow.power === power
  )
    return row;

  const powerValid = isPowerValid(power) === true && !isEmpty(power);
  const deltaTValid =
    isDifferentialTemperatureValid(deltaT) === true && deltaT !== "";
  if (!powerValid || !deltaTValid) return { ...row, flow: "" };

  const powerCI = convertToInternationalUnit(Number(power), "PHYS_TH_POWER");
  const deltaTCI = convertToInternationalUnit(Number(deltaT), "PHYS_DIFFTEMP");
  const [errors, flow] = utilsRepository.convertPowerToFlow(
    powerCI,
    deltaTCI,
    waterCharacteristics,
  );
  if (errors) {
    return {
      ...row,
      flow: "",
      inputErrors: unique(errors.map((error) => error.path)).reduce(
        (acc, path) => {
          return set(
            acc,
            path,
            errors.find((error) => error.path === path),
          );
        },
        {},
      ),
    };
  }
  if (flow === null) return { ...row, flow: "", inputErrors: {} };
  return {
    ...row,
    flow: `${convertToUserUnit(flow, "PHYS_FLOW")}`,
    inputErrors: {},
  };
}
